import type { VideoVoting } from 'open-modules/zdf/component/videovoting/videovoting-types';

// General structure of the voting. No results or state
/** @public */
export const endometriosisVideoVotingDE: VideoVoting = {
    name: 'Endometriosis',
    votingKey: 'endometriosis-voting',
    createdBy: 'a',
    createdAt: '2024-01-01T00:00:00.000Z',
    editedAt: null,
    videoUrl: null,
    linkedSpaceKey: null,
    chapters: [
        {
            key: 'chapter-0',
            name: 'Chapter 1',
        },
        {
            key: 'chapter-1',
            name: 'Chapter 2',
        },
    ],
    questions: [
        {
            text: 'Hast du schon mal von Endometriose gehört?',
            key: 'endometriosis-voting-question-0',
            type: 'poll',
            timestamp: 0,
            initial: true,
            options: [
                {
                    key: 'endometriosis-voting-question-0-option-0',
                    text: 'Ja',
                },
                {
                    key: 'endometriosis-voting-question-0-option-1',
                    text: 'Nein',
                },
            ],
        },
        {
            text: 'Wie wichtig ist es für Betroffene, dass die Erkrankung und der damit einhergehende Leidensdruck anerkannt wird?',
            timestamp: 638,
            key: 'endometriosis-voting-question-1',
            type: 'poll',
            options: [
                {
                    key: 'endometriosis-voting-question-1-option-0',
                    text: 'Sehr wichtig, da Endometriose den Alltag der Betroffenen sehr einzuschränken scheint.',
                },
                {
                    key: 'endometriosis-voting-question-1-option-1',
                    text: 'Wichtig, wie bei allen anderen Erkrankungen auch.',
                },
            ],
        },
        {
            text: 'Ist es richtig, dass die Regierung Geld in die Erforschung von "Endometriose" investiert?',
            timestamp: 720,
            key: 'endometriosis-voting-question-2',
            type: 'poll',
            options: [
                {
                    key: 'endometriosis-voting-question-2-option-0',
                    text: 'Ja',
                },
                {
                    key: 'endometriosis-voting-question-2-option-1',
                    text: 'Nein',
                },
                {
                    key: 'endometriosis-voting-question-2-option-2',
                    text: 'Weiß nicht',
                },
            ],
        },
        {
            text: 'Wie wichtig findest du es, dass mehr Menschen über Endometriose Bescheid wissen?',
            key: 'endometriosis-voting-question-3',
            type: 'poll',
            timestamp: 750,
            final: true,
            options: [
                {
                    key: 'endometriosis-voting-question-3-option-0',
                    text: 'Sehr wichtig',
                },
                {
                    key: 'endometriosis-voting-question-3-option-1',
                    text: 'Wichtig',
                },
                {
                    key: 'endometriosis-voting-question-3-option-2',
                    text: 'Nicht wichtig',
                },
            ],
        },
    ],
};

export const endometriosisVideoVotingEN: VideoVoting = {
    name: 'Endometriosis',
    votingKey: 'endometriosis-voting',
    createdBy: 'a',
    createdAt: '2024-01-01T00:00:00.000Z',
    editedAt: null,
    videoUrl: null,
    linkedSpaceKey: null,
    chapters: [
        {
            key: 'chapter-0',
            name: 'Chapter 1',
        },
        {
            key: 'chapter-1',
            name: 'Chapter 2',
        },
    ],
    questions: [
        {
            text: 'Have you ever heard of endometriosis?',
            key: 'endometriosis-voting-question-0',
            type: 'poll',
            timestamp: 0,
            initial: true,
            options: [
                {
                    key: 'endometriosis-voting-question-0-option-0',
                    text: 'Yes',
                },
                {
                    key: 'endometriosis-voting-question-0-option-1',
                    text: 'No',
                },
            ],
        },
        {
            text: 'How important is it to you that this illness and the suffering of those affected get recognized?',
            timestamp: 638,
            key: 'endometriosis-voting-question-1',
            type: 'poll',
            options: [
                {
                    key: 'endometriosis-voting-question-1-option-0',
                    text: 'Very important, because endometriosis restricts the daily lives of those affected',
                },
                {
                    key: 'endometriosis-voting-question-1-option-1',
                    text: 'Important, as with every illness',
                },
            ],
        },
        {
            text: 'Is it right for the government to invest money in research into endometriosis?',
            timestamp: 720,
            key: 'endometriosis-voting-question-2',
            type: 'poll',
            options: [
                {
                    key: 'endometriosis-voting-question-2-option-0',
                    text: 'Yes',
                },
                {
                    key: 'endometriosis-voting-question-2-option-1',
                    text: 'No',
                },
                {
                    key: 'endometriosis-voting-question-2-option-2',
                    text: "I don't know",
                },
            ],
        },
        {
            text: 'How important do you think it is that more people know about endometriosis?',
            key: 'endometriosis-voting-question-3',
            type: 'poll',
            timestamp: 750,
            final: true,
            options: [
                {
                    key: 'endometriosis-voting-question-3-option-0',
                    text: 'Very important',
                },
                {
                    key: 'endometriosis-voting-question-3-option-1',
                    text: 'Important',
                },
                {
                    key: 'endometriosis-voting-question-3-option-2',
                    text: 'Not that important',
                },
            ],
        },
    ],
};

/** @public */
export const cashForTrashVideoVotingEN: VideoVoting = {
    name: 'Cash for Trash',
    votingKey: 'cash4trash-voting',
    chapters: [],
    createdBy: 'a',
    createdAt: '2024-01-01T00:00:00.000Z',
    editedAt: null,
    videoUrl: null,
    linkedSpaceKey: null,
    questions: [
        {
            key: 'cash4trash-voting-question-0',
            type: 'slider',
            text: 'How much is the "Man with Cat" worth?',
            minValue: 0,
            maxValue: 5000,
            stepSize: 100,
            unit: '€',
            timestamp: 90,
            predeterminedAnswers: [
                {
                    text: 'Expert',
                    value: 2000,
                },
            ],
        },
    ],
};

export const godzillaVideoVotingIndividual: VideoVoting = {
    votingKey: 'godzilla-voting',
    createdBy: 'a',
    createdAt: '2024-01-01T00:00:00.000Z',
    editedAt: null,
    name: 'How Much Do You Actually Know About Godzilla?',
    linkedSpaceKey: 'godzilla',
    videoUrl: null,
    chapters: [],
    questions: [
        {
            text: 'Do you believe Godzilla is the ultimate king of monsters?',
            type: 'poll',
            key: 'godzilla-voting-question-0',
            timestamp: 0,
            options: [
                {
                    key: 'godzilla-voting-question-0-option-0',
                    text: 'Yes, all hail the King!',
                },
                {
                    key: 'godzilla-voting-question-0-option-1',
                    text: 'Nah, Mothra’s got my vote.',
                },
            ],
        },
        {
            text: 'How important is it that the world recognizes the destruction Godzilla causes?',
            timestamp: 600,
            type: 'poll',
            key: 'godzilla-voting-question-1',
            options: [
                {
                    key: 'godzilla-voting-question-1-option-0',
                    text: "Extremely important, cities aren't cheap to rebuild!",
                },
                {
                    key: 'godzilla-voting-question-1-option-1',
                    text: "Eh, it's just a bit of property damage, no biggie.",
                },
            ],
        },
        {
            text: 'Should the government fund research to understand why Godzilla has such a bad temper?',
            timestamp: 720,
            type: 'poll',
            key: 'godzilla-voting-question-2',
            options: [
                {
                    key: 'godzilla-voting-question-2-option-0',
                    text: 'Yes, maybe Godzilla just needs a hug.',
                },
                {
                    key: 'godzilla-voting-question-2-option-1',
                    text: "No, we've got bigger issues—like actual volcanoes.",
                },
                {
                    key: 'godzilla-voting-question-2-option-2',
                    text: "I don't know, ask Dr. Serizawa.",
                },
            ],
        },
        {
            text: "How important is it for more people to know about Godzilla's legendary status?",
            key: 'godzilla-voting-question-3',
            timestamp: 840,
            type: 'poll',
            options: [
                {
                    key: 'godzilla-voting-question-3-option-0',
                    text: 'Super important, long live the legend!',
                },
                {
                    key: 'godzilla-voting-question-3-option-1',
                    text: 'Important, but maybe we could let him chill in the ocean.',
                },
                {
                    key: 'godzilla-voting-question-3-option-2',
                    text: "Not important, I'm more of a King Kong person.",
                },
            ],
        },
    ] as const,
} as const;

export const auctionVideoVotingSlider: VideoVoting = {
    name: 'Cash for Trash',
    votingKey: 'auction-voting',
    chapters: [],
    createdBy: 'a',
    createdAt: '2024-01-01T00:00:00.000Z',
    editedAt: null,
    videoUrl: null,
    linkedSpaceKey: null,
    questions: [
        {
            key: 'auction-voting-question-0',
            type: 'slider',
            text: 'How much is this painting worth?',
            minValue: 0,
            maxValue: 500,
            unit: '€',
            stepSize: 10,
            timestamp: 100,
            predeterminedAnswers: [
                {
                    text: 'Expert',
                    value: 200,
                },
            ],
        },
        {
            key: 'auction-voting-question-1',
            type: 'slider',
            text: 'How much will this vase be sold for?',
            minValue: 0,
            maxValue: 1000,
            stepSize: 50,
            unit: '€',
            timestamp: 500,
            predeterminedAnswers: [
                {
                    text: 'Highest bid',
                    value: 100,
                },
            ],
        },
        {
            key: 'auction-voting-question-2',
            type: 'slider',
            text: 'How much would you pay for this antique telephone?',
            minValue: 0,
            maxValue: 3000,
            stepSize: 100,
            unit: '€',
            timestamp: 800,
        },
        {
            key: 'auction-voting-question-3',
            type: 'slider',
            text: 'How much is this book worth?',
            minValue: 0,
            maxValue: 3000,
            stepSize: 100,
            unit: '€',
            timestamp: 900,
            predeterminedAnswers: [
                {
                    text: 'Contestant',
                    value: 150,
                },
                {
                    text: 'Real value',
                    value: 2000,
                },
            ],
        },
        {
            key: 'auction-voting-question-4',
            type: 'slider',
            text: 'How many marbles are in the jar?',
            minValue: 0,
            maxValue: 200,
            stepSize: 5,
            timestamp: 1000,
            predeterminedAnswers: [
                {
                    text: 'Actual number',
                    value: 59,
                },
            ],
        },
        {
            key: 'auction-voting-question-5',
            type: 'slider',
            text: 'How much is this jar of marbles worth?',
            minValue: 0,
            maxValue: 3000,
            stepSize: 100,
            unit: '$',
            isUnitBeforeValue: true,
            timestamp: 1100,
            predeterminedAnswers: [
                {
                    text: 'Real value',
                    value: 2000,
                },
            ],
        },
        {
            key: 'auction-voting-question-6',
            type: 'slider',
            text: 'How much would you pay for this jar of marbles?',
            minValue: 0,
            maxValue: 3000,
            stepSize: 100,
            unit: '$',
            isUnitBeforeValue: true,
            timestamp: 1200,
        },
    ],
};
// Example video voting with chapters
export const chapterVideoVoting: VideoVoting = {
    name: 'Trash or Treasure?',
    votingKey: 'chapter-voting',
    createdBy: 'a',
    createdAt: '2024-01-01T00:00:00.000Z',
    editedAt: null,
    videoUrl: null,
    linkedSpaceKey: null,
    // These chapters are deliberately out of order to test if chronological
    // sorting works correctly
    chapters: [
        {
            key: 'chapter-1',
            name: 'Bovine',
        },
        {
            key: 'chapter-2',
            name: 'Golden pin',
        },
        {
            key: 'chapter-4',
            name: 'Wristband with pearls',
        },
        {
            key: 'chapter-3',
            name: 'Woven chairs',
        },
        {
            key: 'chapter-0',
            name: 'Man with Cat',
        },
        // Chapter without questions. This should not appear in the voting
        // results.
        {
            key: 'chapter-5',
            name: 'Empty',
        },
    ],
    // These question are deliberately out of order to test if sorting them
    // works correctly
    questions: [
        {
            text: 'Would you buy this sculpture?',
            key: 'chapter-voting-question0',
            chapterKey: 'chapter-0',
            timestamp: 90,
            type: 'poll',
            options: [
                {
                    key: 'chapter-voting-question0-option0',
                    text: 'Yes!',
                },
                {
                    key: 'chapter-voting-question0-option1',
                    text: 'No...',
                },
                {
                    key: 'chapter-voting-question0-option2',
                    text: 'Maybe if it was cheaper?',
                },
            ],
        },
        {
            text: 'Is this sculpture ugly?',
            key: 'chapter-voting-question1',
            chapterKey: 'chapter-0',
            timestamp: 270,
            type: 'poll',
            options: [
                {
                    key: 'chapter-voting-question1-option0',
                    text: 'Yes...',
                },
                {
                    key: 'chapter-voting-question1-option1',
                    text: "No, it's art!",
                },
            ],
        },
        {
            text: 'Is this a cow or a bull?',
            key: 'chapter-voting-question2',
            chapterKey: 'chapter-1',
            timestamp: 630,
            type: 'poll',
            options: [
                {
                    key: 'chapter-voting-question2-option0',
                    text: 'Cow',
                },
                {
                    key: 'chapter-voting-question2-option1',
                    text: 'Bull',
                },
            ],
        },
        {
            text: 'What occasion would you wear this pin to?',
            key: 'chapter-voting-question3',
            chapterKey: 'chapter-2',
            timestamp: 1359,
            type: 'poll',
            options: [
                {
                    key: 'chapter-voting-question3-option0',
                    text: 'My wedding',
                },
                {
                    key: 'chapter-voting-question3-option1',
                    text: 'The Vienna Opera Ball... if I was invited',
                },
                {
                    key: 'chapter-voting-question3-option2',
                    text: "I wouldn't wear it at all, I wouldn't want to lose it!",
                },
            ],
        },
        {
            text: 'Do you think these chairs are rare?',
            key: 'chapter-voting-question4',
            chapterKey: 'chapter-3',
            timestamp: 1815,
            type: 'poll',
            options: [
                {
                    key: 'chapter-voting-question4-option0',
                    text: 'Yes, they are special!',
                },
                {
                    key: 'chapter-voting-question4-option1',
                    text: "No, I've seen chairs like that a million times",
                },
            ],
        },
        {
            text: "Does antique jewelry look better than today's?",
            key: 'chapter-voting-question5',
            chapterKey: 'chapter-4',
            timestamp: 2529,
            type: 'poll',
            options: [
                {
                    key: 'chapter-voting-question5-option0',
                    text: "No, it's just different",
                },
                {
                    key: 'chapter-voting-question5-option1',
                    text: 'Yes, modern jewelry looks cheap and boring',
                },
                {
                    key: 'chapter-voting-question5-option2',
                    text: "I don't wear jewelry, I couldn't care less",
                },
            ],
        },
        {
            text: 'Do you think this sculpture is made out of bronze?',
            key: 'chapter-voting-question6',
            chapterKey: 'chapter-1',
            timestamp: 500,
            type: 'poll',
            options: [
                {
                    key: 'chapter-voting-question6-option0',
                    text: 'Yes, it looks like bronze to me',
                },
                {
                    key: 'chapter-voting-question6-option1',
                    text: 'No, there are other materials that look the same',
                },
            ],
        },
        {
            text: 'If this sculpture was gifted to you, would you re-gift it to someone else?',
            key: 'chapter-voting-question7',
            chapterKey: 'chapter-0',
            timestamp: 880,
            type: 'poll',
            options: [
                {
                    key: 'chapter-voting-question7-option0',
                    text: 'No, of course I would keep it!',
                },
                {
                    key: 'chapter-voting-question7-option1',
                    text: "Yes, I don't want that thing in my home",
                },
            ],
        },
    ],
};

// Example video voting with chapters and questions that are not assigned to a
// chapter
export const chapterQuestionMixVideoVoting: VideoVoting = {
    name: 'Trash or Treasure? Pt. 2',
    votingKey: 'chapter-question-mix-voting',
    createdBy: 'a',
    createdAt: '2024-01-01T00:00:00.000Z',
    editedAt: null,
    videoUrl: null,
    linkedSpaceKey: null,
    // These chapters are deliberately out of order to test if chronological
    // sorting works correctly
    chapters: [
        {
            key: 'chapter-1',
            name: 'Antique telephone',
        },
        {
            key: 'chapter-0',
            name: 'Flower vase',
        },
        // Chapter without questions. This should not appear in the voting
        // results.
        {
            key: 'chapter-2',
            name: 'Empty',
        },
    ],
    // These question are deliberately out of order to test if sorting them
    // works correctly
    questions: [
        {
            text: 'What flowers would you put in this vase?',
            key: 'chapter-question-mix-voting-question0',
            chapterKey: 'chapter-0',
            timestamp: 90,
            type: 'poll',
            options: [
                {
                    key: 'chapter-question-mix-voting-question0-option0',
                    text: 'Roses',
                },
                {
                    key: 'chapter-question-mix-voting-question0-option1',
                    text: 'Tulips',
                },
                {
                    key: 'chapter-question-mix-voting-question0-option2',
                    text: 'Something else',
                },
            ],
        },
        {
            text: 'Have you ever dropped an expensive vase?',
            key: 'chapter-question-mix-voting-question1',
            chapterKey: 'chapter-0',
            timestamp: 120,
            type: 'poll',
            options: [
                {
                    key: 'chapter-question-mix-voting-question1-option0',
                    text: 'Yes, unfortunately',
                },
                {
                    key: 'chapter-question-mix-voting-question1-option1',
                    text: 'No, luckily not!',
                },
                {
                    key: 'chapter-question-mix-voting-question1-option2',
                    text: 'No, but my cat knocked one over...',
                },
            ],
        },
        {
            text: 'Who invented the telephone?',
            key: 'chapter-question-mix-voting-question2',
            chapterKey: 'chapter-1',
            timestamp: 400,
            type: 'poll',
            options: [
                {
                    key: 'chapter-question-mix-voting-question2-option0',
                    text: 'Thomas Edison',
                },
                {
                    key: 'chapter-question-mix-voting-question2-option1',
                    text: 'Alexander Graham Bell',
                },
                {
                    key: 'chapter-question-mix-voting-question2-option2',
                    text: 'Someone else',
                },
            ],
        },
        {
            text: 'Do you still have a landline phone at home?',
            key: 'chapter-question-mix-voting-question3',
            chapterKey: 'chapter-1',
            timestamp: 300,
            type: 'poll',
            options: [
                {
                    key: 'chapter-question-mix-voting-question3-option0',
                    text: "No, I don't know anyone who does",
                },
                {
                    key: 'chapter-question-mix-voting-question3-option1',
                    text: 'No, but part of my family still does',
                },
                {
                    key: 'chapter-question-mix-voting-question3-option2',
                    text: 'Yes!',
                },
            ],
        },
        // Question without chapter assigned
        {
            text: 'Have you ever been to an auction?',
            key: 'chapter-question-mix-voting-question4',
            timestamp: 0,
            initial: true,
            type: 'poll',
            options: [
                {
                    key: 'chapter-question-mix-voting-question4-option0',
                    text: 'Yes',
                },
                {
                    key: 'chapter-question-mix-voting-question4-option1',
                    text: 'No',
                },
                {
                    key: 'chapter-question-mix-voting-question4-option2',
                    text: 'Do online auctions count?',
                },
            ],
        },
    ],
};
